module.exports = __webpack_public_path__ + "img/empty-chat.e596754f.svg";